import { useEffect, useState } from "react";

/* // APIFuncitons.js
import {
  // get static data
  getLeaders,
  getTourTags,
  getAttractions,
  getEssentialsAccessories,
  getCities,
  getUserTags,
  // get dynamic data
  getTourDetails,
  getAdditionalCost,
  getReservePrograms,
  getDailyInfo,
  getTables,
  // save data
  saveTourDetails,
  saveAdditionalCost,
  saveReservePrograms,
  saveDailyInfo,
  saveTables,
} from "../admin-panel/create-tours/APIFunctions"; */

/* //FinancialDepartment.js
import { getInfo, checkInventory, insertTransaction, updateTransaction, deleteTransaction } from "../services/FinancialDepartment"; */

/* import { getProfileInfo, getVisits } from "../services/userReport.js"; */

/* import { getUserDashboard, getAdminDashboard } from "../services/dashboard.js"; */

import { checkImageExistence } from "../services/services";
import image from "../assets/image/exchange (1).png";

export default function Test() {
  const [file, setFile] = useState();

  /* async function APIFunctions() {
    const Types = {
      getStaticData: 1,
      getDynamicData: 2,
      saveData: 3,
    };
    const DailyInfo = [
      [
        {
          title: "گشت صبح",
          price: "0",
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: "0",
          id: 1,
          foodName: "",
          resturan: "",
          tel: "0",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: "0",
          id: 2,
          foodName: "",
          resturan: "",
          tel: "1",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: "0",
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: "0",
          id: 5,
          foodName: "",
          resturan: "",
          tel: "3",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noeEghamat: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "برنامه شب",
          price: "0",
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
        {
          title: " زمان",
          datepick: "1644734449000",
          id: 10,
          status: false,
          isPublic: true,
        },
        {
          title: " محل",
          name: "sadasd",
          id: 11,
          status: false,
          isPublic: true,
        },
        {
          title: " مبدا",
          name: {
            id: 0,
            title: "",
          },
          id: 12,
        },
        {
          title: "ظرفیت",
          name: "",
          id: 13,
          status: false,
          isPublic: true,
        },
        {
          title: "نمایشی",
          name: "",
          id: 14,
          status: false,
          isPublic: true,
        },
        {
          title: " بیمه",
          price: "0",
          id: 15,
          status: false,
          isPublic: true,
        },
        {
          title: " ترنسفر",
          name: "",
          value: "",
          trans: "",
          id: 16,
          status: false,
          isPublic: true,
        },
        {
          title: " ترنسفر قیمت",
          price: "0",
          id: 17,
          status: false,
          isPublic: true,
        },
        {
          title: " سیم کارت",
          price: "0",
          id: 18,
          status: false,
          isPublic: true,
        },
        {
          title: "نام ترنسفر",
          name: "",
          value: "",
          trans: "",
          id: 19,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: "",
          onvan: "",
          description: "",
          id: 7,
          status: false,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: "",
          onvan: "",
          description: "",
          id: 7,
          status: true,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: "",
          onvan: "",
          description: "",
          id: 7,
          status: true,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: "",
          onvan: "",
          description: "",
          id: 7,
          status: true,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: "",
          onvan: "",
          description: "",
          id: 7,
          status: true,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: "",
          onvan: "",
          description: "",
          id: 7,
          status: true,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: "",
          onvan: "",
          description: "",
          id: 7,
          status: true,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: "",
          onvan: "",
          description: "",
          id: 7,
          status: true,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: "",
          onvan: "",
          description: "",
          id: 7,
          status: true,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
      [
        {
          title: "گشت صبح",
          price: 0,
          id: 0,
          onvan: "",
          description: "",
          status: false,
          isPublic: true,
        },
        {
          title: "صبحانه",
          price: 0,
          id: 1,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "ناهار",
          price: 0,
          id: 2,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "میان وعده",
          price: "0",
          id: 3,
          onvan: "",
          status: false,
          isPublic: true,
        },
        {
          title: "گشت عصر ",
          price: 0,
          onvan: "",
          description: "",
          id: 4,
          status: false,
          isPublic: true,
        },
        {
          title: "شام",
          price: 0,
          id: 5,
          foodName: "",
          resturan: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
        },
        {
          title: "اقامتگاه",
          price: "0",
          id: 6,
          onvan: "",
          noe: "",
          tel: "",
          address: "",
          status: false,
          isPublic: true,
          noeEghamat: "",
        },
        {
          title: "برنامه شب",
          price: "",
          onvan: "",
          description: "",
          id: 7,
          status: true,
          isPublic: true,
        },
        {
          title: " نقلیه کمکی",
          price: "0",
          vehValue: "",
          noe: [
            {
              title: "",
              id: "",
            },
          ],
          capacity: "",
          id: 8,
          status: false,
          isPublic: true,
        },
        {
          title: " هوا",
          weather: "",
          id: 9,
          status: false,
          isPublic: true,
        },
      ],
    ];
    const Tables = [
      [
        {
          name: "هزینه ترنسفر",
          fixedCosts: 0,
          nextRun: 0,
          id: 1,
        },
        {
          name: "هزینه های ثابت راننده و لیدر",
          fixedCosts: 0,
          nextRun: 0,
          id: 2,
        },
        {
          name: "هزینه اقامتگاه در حالت دربستی",
          fixedCosts: 0,
          nextRun: 0,
          id: 3,
        },
        {
          name: "موسیقی محلی و سورپرایز",
          fixedCosts: 123123,
          nextRun: 0,
          id: 4,
        },
        {
          name: "وروذی های اتوبوس",
          fixedCosts: 0,
          nextRun: 0,
          id: 5,
        },
        {
          name: "وروذی های اتوبوس",
          fixedCosts: 0,
          nextRun: 0,
          id: 6,
        },
        {
          name: "هزینه تبلیغات",
          fixedCosts: 234234,
          nextRun: 0,
          id: 7,
        },
        {
          name: "پورسانت کل کانتر فروش",
          fixedCosts: 0,
          nextRun: 0,
          id: 8,
        },
        {
          name: "مجموعه هزینه های ثابت",
          fixedCosts: 0,
          nextRun: 0,
          id: 9,
        },
        {
          name: "هزینه های پیش بینی نشد",
          fixedCosts: 2342342,
          nextRun: 0,
          id: 10,
        },
        {
          name: "جمع نهایی",
          fixedCosts: 0,
          nextRun: 0,
          id: 11,
        },
      ],
      [
        {
          name: "هزینه ثابت",
          estimate: 0,
          capacity: 0,
          nextRun: 0,
          id: 1,
        },
        {
          name: "هزینه های متغیر",
          estimate: 0,
          capacity: 0,
          nextRun: 0,
          id: 2,
        },
        {
          name: "کمسیون آزانس",
          estimate: 0,
          nextRun: 0,
          id: 3,
        },
        {
          name: "هزینه نهایی",
          estimate: 0,
          capacity: 0,
          nextRun: 0,
          id: 4,
        },
        {
          name: "قیمت فروش",
          estimate: 0,
          nextRun: 0,
          id: 5,
        },
        {
          name: "حاشیه سود",
          estimate: 0,
          capacity: 0,
          nextRun: 0,
          id: 6,
        },
        {
          name: "براورد سود",
          estimate: 0,
          capacity: 0,
          nextRun: 0,
          id: 7,
        },
        {
          name: "",
          estimate: 0,
          capacity: 0,
          id: 8,
        },
      ],
      [
        {
          name: "صبحانه",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 1,
        },
        {
          name: "ناهار",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 2,
        },
        {
          name: "شام",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 3,
        },
        {
          name: "اقامت",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 4,
        },
        {
          name: "ترنسفر اصلی لیدر",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 5,
        },
        {
          name: "ترنسفر کمکی لیدر",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 6,
        },
        {
          name: "دستمزد لیدر",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 7,
        },
        {
          name: "لیدر محلی",
          nafar: 0,
          tedad: 0,
          gheimatVahed: 0,
          gheimatKol: 0,
          badeEjra: 0,
          id: 8,
        },
        {
          name: "جمع کل هزینه های ثابت",
          gheimatKol: 0,
          badeEjra: 0,
          id: 9,
        },
      ],
    ];
    let res,
      id = 86,
      method = Types.getDynamicData;

    if (method == Types.getStaticData) {
      res = await getLeaders();
      console.log("getLeaders", res);
      res = await getTourTags();
      console.log("getTourTags", res);
      res = await getAttractions();
      console.log("getAttractions", res);
      res = await getEssentialsAccessories();
      console.log("getEssentialsAccessories", res);
      res = await getCities();
      console.log("getCities", res);
      res = await getUserTags();
      console.log("getUserTags", res);
    }

    if (method == Types.getDynamicData) {
      res = await getTourDetails(id);
      console.log("getTourDetails", res);
      res = await getAdditionalCost(id);
      console.log("getAdditionalCost", res);
      res = await getReservePrograms(id);
      console.log("getReservePrograms", res);
      res = await getDailyInfo(id);
      console.log("getDailyInfo", res);
      res = await getTables(id);
      console.log("getTables", res);
    }

    if (method == Types.saveData) {
      res = await saveTourDetails({
        id: -1,
        title: "",
        city: { id: 2, name: "گرگان" },
        mainprice: 0,
        stm: 0,
        ftm: 0,
        hardshiplevel: 0,
        visa: 0,
        insurance: 0,
        tourleaderuid: 0,
        isspecial: 0,
        main_status: 4,
        essentials_accessories: "",
        attractions: [
          { id: 2, title: "مسجد جامع" },
          { id: 10, title: "سوباتان" },
        ],
        tour_tags: [
          { id: 9, title: "ایرانگردی" },
          { id: 10, title: "یکروزه" },
        ],
        trip_type: "",
        essentials: "",
      });
      console.log("saveTourDetails", res);
      res = await saveAdditionalCost(id, [
        {
          title: "تست 1",
          cost: 1000,
          tour_id: id,
        },
      ]);
      console.log("saveAdditionalCost", res);
      res = await saveReservePrograms(id, [
        {
          stm: 1644131515,
          ftm: 1644151515,
          prepay: 1000,
          user_tag_id: 3,
          tour_id: id,
        },
      ]);
      console.log("saveReservePrograms", res);
      res = await saveDailyInfo(id, DailyInfo);
      console.log("saveDailyInfo", res);
      res = await saveTables(id, Tables);
      console.log("saveTables", res);
    }
  } */

  /* async function FinancialDepartment() {
    const Types = {
      get: 1,
      check: 2,
      insert: 3,
      update: 4,
      delete: 5,
    };
    let res,
      transactionId = 2,
      fromWalletId = 5,
      toWalletId = 8,
      method = Types.get;
    if (method == Types.get) {
      res = await getInfo();
      console.log("getInfo", res);
    }
    if (method == Types.check) {
      res = await checkInventory(fromWalletId, 5000000);
      console.log("checkInventory", res);

      res = await checkInventory(toWalletId, 100000000, transactionId);
      console.log("checkInventory", res);
    }
    if (method == Types.insert) {
      res = await insertTransaction({
        price: 100000,
        type: 1,
        mtm: 1644147781000,
        walletId: 11,
      });
      console.log("insertTransaction Type 1", res);

      res = await insertTransaction({
        price: 100000,
        type: 2,
        mtm: 1644147781000,
        fromWalletId: fromWalletId,
        toWalletId: toWalletId,
      });
      console.log("insertTransaction Type 2", res);

      res = await insertTransaction({
        price: 100000,
        type: 2,
        mtm: 1644147781000,
        fromWalletId: toWalletId,
        toWalletId: fromWalletId,
      });
      console.log("insertTransaction Type 2", res);

      res = await insertTransaction({
        price: 100000,
        type: 3,
        mtm: 1644147781000,
        walletId: 11,
      });
      console.log("insertTransaction Type 3", res);
    }
    if (method == Types.update) {
      res = await updateTransaction(13, {
        price: 100000,
        type: 3,
        pervType: 1,
        mtm: 1644147781000,
        walletId: 11,
      });
      console.log("updateTransaction", res);
      res = await updateTransaction(31, {
        price: 500000,
        type: 2,
        pervType: 2,
        mtm: 1644147781000,
        fromWalletId: 5,
        toWalletId: 10,
      });
      console.log("updateTransaction", res);
    }
    if (method == Types.delete) {
      res = await deleteTransaction(11, 1);
      console.log("deleteTransaction", res);
    }
  } */

  /* async function UserReport() {
    let res;
    res = await getProfileInfo(90);
    console.log("getProfileInfo", res);
    res = await getVisits(4);
    console.log("getVisits", res);
    res = await getInfo(174);
    console.log("getInfo", res);
  } */

  /* async function Dashboards() {
    let res;
    res = await getUserDashboard(90);
    console.log("getUserDashboard", res);
    res = await getAdminDashboard();
    console.log("getAdminDashboard", res);
  } */

  function clickHandler() {
    // APIFunctions();
    // FinancialDepartment();
    // UserReport();
    // Dashboards();
    // checkImageExistence("500r-(1).jpg");
    // checkImageExistence("undefined");
  }

  function fileHandler(e) {
    setFile(e.target.files[0]);
  }

  return (
    <div className="d-flex flex-column align-items-center">
      <h1>This is a testing page for API connections</h1>
      <div>
        <input type="file" onChange={fileHandler} />
        <button className="btn btn-primary" onClick={clickHandler}>
          {" "}
          Click{" "}
        </button>
        <div style={{ backgroundColor: "red" }}>
          <img src={image} style={{ width: "50%" }} />
        </div>
      </div>
    </div>
  );
}
